import { Event } from "../../contracts";

/*tslint:disable:no-null-keyword */
export const mapParticipants = (x: Event): Event => {
    const emptyParticipant = {
        id: "",
        name: "",
        venueRole: null,
        country: "",
        metadata: {},
    };

    for (let i = 0; i < 2; i++) {
        if (x.participants.length <= i) {
            x.participants.push(emptyParticipant);
        } else {
            x.participants[i] = { ...emptyParticipant, ...x.participants[i] };
        }
    }

    return x;
}
